export default function UserName(props) {
    let patreonLvl = 0
    if (props.name == "YellowPiouPiou") {
        patreonLvl = 4
    }
    if (props.name == "Warfun" || props.name == "Ajordat") {
        patreonLvl = 3
    }
    return(<p class={"user-name ms-0 mn-0 patreon opacity-100 patreon-" + patreonLvl + (props.className ? " " + props.className : "")}>{props.name}</p>)
}